import React, { useState } from "react";
import styled, { ThemeProvider } from "styled-components";
import { connect } from "react-redux";

import SideMenu from "../components/SideMenu";
import TweetArea from "../components/TweetArea";
import TweetReply from "../components/TweetReply";
import SearchBar from "../components/SearchBar";
import themes from "../theme";
import MobileHeader from "../components/mobile/Header";
import FilterIcon from "../components/icons/MobileFilter";
import SearchArea from "../components/SearchArea";
import { switchTheme } from "../theme/data/actions";
import { handleSettingsClick } from "./data/actions";
import appUrls from "../config/appUrls";
import { getDevice, devices } from "../services/getDevice";

const SearchFilter = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
  @media (max-width: 575px) {
    display: flex;
    align-items: center;
  }
`;

const BlurLayer = styled.div`
  display: ${props => (props.show ? "inherit" : "none")};
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  backdrop-filter: ${props =>
    props.show ? "blur(30px) brightness(1)" : "none"};
  background-color: rgba(112, 112, 112, 0.15);
  z-index: ${props => (props.isMobileReply ? 8 : 6)};
`;

const MobileFilter = styled(FilterIcon)`
  position: absolute;
  right: 25px;
`;

const LoggedInWrapper = ({
  children,
  pathname,
  theme,
  setTheme,
  handleSettingsClick,
  isLoading
}) => {
  const [isReplyOpen, setReplyOpen] = useState(false);
  const [isSearchOpen, setSearchOpen] = useState(false);
  const [isMobileTweetAreaOpen, setMobileTweetArea] = useState(false);
  const isMobile = getDevice() === devices.mobile;

  console.log(isLoading);

  return (
    <ThemeProvider theme={themes[theme]}>
      <>
        <BlurLayer
          show={
            isReplyOpen || (isSearchOpen && !isMobile) || isMobileTweetAreaOpen
          }
          isMobileReply={isReplyOpen && isMobile}
        />
        <MobileHeader
          onTweetShow={setMobileTweetArea}
          isSearch={isSearchOpen}
          searchClose={() => setSearchOpen(false)}
        />
        <TweetReply open={isReplyOpen} onClose={() => setReplyOpen(false)} />
        <SearchArea open={isSearchOpen} onClose={() => setSearchOpen(false)} />
        <>
          <SideMenu
            onThemeSwitch={() => {
              setTheme(theme === "light" ? "dark" : "light");
            }}
          />
          <>
            <SearchFilter>
              <SearchBar
                open={isSearchOpen}
                onClose={() => setSearchOpen(false)}
                onOpen={() => setSearchOpen(true)}
              />
              <MobileFilter
                onClick={handleSettingsClick}
                background={
                  pathname !== appUrls.CHANNEL &&
                  pathname !== appUrls.KPIS &&
                  pathname !== appUrls.HOME
                }
              />
            </SearchFilter>
            {children}
          </>
          <TweetArea
            mobileOpen={isMobileTweetAreaOpen}
            onMobileClose={setMobileTweetArea}
            onReplyClick={() => setReplyOpen(true)}
          />
        </>
      </>
    </ThemeProvider>
  );
};

const mapStateToProps = state => ({
  pathname: state.router.location.pathname,
  theme: state.themes.theme,
  isLoading: state.app.isLoading
});

const mapDispatchToProps = {
  setTheme: switchTheme,
  handleSettingsClick
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoggedInWrapper);
